import React, { useState, useEffect } from "react";
import "./Styles/style.scss";

import Header from "./Sections/Header";
import Start from "./Sections/Start";
import Teaser from "./Sections/Teaser";
import About from "./Sections/About";
import Training from "./Sections/Training";
// import PhotosEvents from "./Sections/PhotosEvents";
import PhotosEvents_New from "./Sections/PhotosEvents_New";
import Anpaddeln_Form from "./Sections/Anpaddeln_Form";
import Contact from "./Sections/Contact";
import Footer from "./Sections/Footer";
import Imprint from "./Sections/Imprint";

import { MdClose } from "react-icons/md";
import { getContentfulEntries } from "./contentful";

import VisitorTracker from "./VisitorTracker";
import VisitorDashboard from "./VisitorDashboard";

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDSqpy4LmsqQrr2PmMxnwQ0CjTjcMwHGNs",
  authDomain: "caipiranhas.firebaseapp.com",
  databaseURL:
    "https://caipiranhas-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "caipiranhas",
  storageBucket: "caipiranhas.appspot.com",
  messagingSenderId: "788508180855",
  appId: "1:788508180855:web:997e50c465700f531c2172",
};

// Firebase initialisieren
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

function App() {
  const isMobile = window.innerWidth < 670;
  const [banner, setBanner] = useState([]);
  const [mBanner, setMBanner] = useState([]);
  const [bannerActive, setBannerActive] = useState([]);
  const [isAnpaddeln, setBannerIsAnpaddeln] = useState([]);
  const [isAnpaddelnActive, setIsAnpaddelnActive] = useState(false);

  // Lazy initialization um Initial-Render des Trackers zu verhindern
  const [showAnalytics, setShowAnalytics] = useState(() => {
    return new URLSearchParams(window.location.search).has("showAnalytics");
  });

  const [password, setPassword] = useState("");
  // Admin-Status aus localStorage laden
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAdmin") === "true";
  });

  const checkPassword = () => {
    if (password === "caipis2024") {
      setIsAuthenticated(true);
      localStorage.setItem("isAdmin", "true"); // Login merken
    } else {
      alert("Falsches Passwort");
    }
  };

  const handleAnpaddelnLinkClick = (state) => {
    setIsAnpaddelnActive(state);
  };

  useEffect(() => {
    getContentfulEntries().then((entries) => {
      // let banner;
      const urlParams = new URLSearchParams(window.location.search);
      const forceAnpaddeln = urlParams.has("anpaddeln");

      entries.items.map((entry) => {
        if (entry.sys.contentType.sys.id === "banner") {
          setMBanner(entry.fields.banner_mobile.fields.file.url);
          setBanner(entry.fields.banner_image.fields.file.url);

          if (forceAnpaddeln) {
            setBannerActive(true);
            setBannerIsAnpaddeln(true);
          } else {
            setBannerActive(entry.fields.active);
            setBannerIsAnpaddeln(entry.fields.isAnpaddeln);
          }
        }
      });
    });
  }, []);

  // URL-Parameter überprüfen
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setShowAnalytics(urlParams.has("showAnalytics"));

    // URL-Parameter-Änderungen überwachen
    const handleUrlChange = () => {
      const urlParams = new URLSearchParams(window.location.search);
      setShowAnalytics(urlParams.has("showAnalytics"));
    };

    // Listener für History-Änderungen hinzufügen
    window.addEventListener("popstate", handleUrlChange);

    // Cleanup
    return () => {
      window.removeEventListener("popstate", handleUrlChange);
    };
  }, []);

  // Wenn showAnalytics true ist, nur das Analytics-Dashboard anzeigen
  if (showAnalytics) {
    if (!isAuthenticated) {
      return (
        <div className="auth-container">
          <div className="auth-card">
            <h3>Analytics Login</h3>
            <input
              type="password"
              placeholder="Passwort eingeben"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && checkPassword()}
            />
            <button onClick={checkPassword}>Login</button>
            <a href="/" className="back-link">
              Zurück zur Webseite
            </a>
          </div>
        </div>
      );
    }

    return (
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>Analytics</h1>
          <a href="/" className="back-btn">
            Zurück zur Webseite
          </a>
        </div>
        <VisitorDashboard />
      </div>
    );
  }

  // Die normale Webseite anzeigen, wenn showAnalytics false ist
  return (
    <>
      <Header />
      <main>
        <Start />
        {banner &&
          (bannerActive === "true" || bannerActive === true) &&
          (!isMobile ? (
            <div style={{ backgroundColor: "#d4edfc", padding: "0px 0 0px 0" }}>
              <img
                src={banner}
                className="divider"
                style={{
                  display: "block",
                  width: "100%",
                  margin: "0 auto",
                }}
              />
            </div>
          ) : (
            <div style={{ backgroundColor: "#d4edfc", padding: "0px 0 0px 0" }}>
              <img
                src={mBanner}
                className="divider"
                style={{
                  display: "block",
                  width: "100%",
                  margin: "0 auto",
                }}
              />
            </div>
          ))}
        {banner &&
          (bannerActive === "true" || bannerActive === true) &&
          (isAnpaddeln === "true" || isAnpaddeln === true) && (
            <div>
              <a
                href=""
                className="open--form--link"
                onClick={(e) => {
                  e.preventDefault();
                  handleAnpaddelnLinkClick(true);
                }}
              >
                Jetzt Anmelden
              </a>
              {isAnpaddelnActive && (
                <div className={`anpaddelnOverlayed`}>
                  <div className="anpaddelnOverlayed--header">
                    <h4>Anmeldung Anpaddeln 2026</h4>
                    <span>
                      <MdClose
                        onClick={(e) => {
                          e.preventDefault();
                          handleAnpaddelnLinkClick(false);
                        }}
                      />
                    </span>
                  </div>
                  <Anpaddeln_Form />
                </div>
              )}
            </div>
          )}
        <Teaser />
        <About />
        <Training />
        {/* <PhotosEvents /> */}
        <PhotosEvents_New />
        <Contact />
      </main>
      <Footer />
      <Imprint />
      <VisitorTracker />
    </>
  );
}

export default App;
